/**
 * Preferences Saga
 */
/* tslint:disable:space-before-function-paren */

import { getItemFromLocalStorage } from '../actions/localStorage';
import * as actions from '../actions/preferences';

import { effects as fx } from 'redux-saga';
import { Action, Success } from 'typescript-fsa';
import { localStorageSuffixPreferences } from '../helpers/localStorage';

type FoundLocalStorageItemAction =
  Action<Success<IGetItemFromLocalStorageActionPayload, ILocalStorageItem<IPreferencesState>>>;

export function* init() {
  yield fx.call(retrieveCheckoutFromLocalStorage);
}

function* retrieveCheckoutFromLocalStorage() {
  while (true) {
    yield fx.take(actions.requestSetPreferencesFromLocalStorage);
    yield fx.put(actions.setPreferencesFromLocalStorage.started);
    yield fx.put(getItemFromLocalStorage.started({ key: localStorageSuffixPreferences }));
    const res: FoundLocalStorageItemAction = yield fx.take(getItemFromLocalStorage.done);
    yield fx.put(actions.setPreferencesFromLocalStorage.done({
      params: undefined,
      result: res.payload.result.data,
    }));
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/sagas/preferences.ts